{
    "menu":{
        "realTime":"Tiempo Real",
        "alerts":"Alertas",
        "history":"Historial",
        "licensePlates":"Cadastro de Alertas",
        "events":"Eventos",
        "tooltip":{
            "alertHistory":"Historial",
            "plateRegistration":"Cadastro de Alertas"
        }
    },
    "headerMenu":{
        "logOut":"Salir",
        "changePassword": "Cambiar Contraseña",
        "languageOptions":{
            "portuguese":"Portugués",
            "spanish":"Español",
            "english":"Inglés"
        }
    },
    "shared":{
        "filter":{
            "filterLabel":"Filtrar",
            "filterCleanLabel":"Limpiar Filtros",
            "filterMostRecent":"Más Recientes",
            "filterSelectOption":"Seleccione una opción",
            "filterOlder":"Más Antiguos",
            "filterPlate":"Placa",
            "filterEquipment":"Equipo",
            "filterAlertType":"Tipo de Alerta",
            "filterShowAll":"Mostrar todos",
            "registrationDate":"Fecha de Registro",
            "deadline":"Plazo",
            "filterSelectedAlertType":"motivo seleccionado",
            "filterSelectedAlertsType":"motivos seleccionados"
        },
        "placeholder":{
            "select":"Seleccionar",
            "selectDeadline":"Seleccione un plazo"
        },
        "details":{
            "detailsTitle":"Detalles del Alerta",
            "remarks":"Observaciones",
            "save":"Guardar"
        },
        "table":{
            "detail":"Detallar",
            "pageReport":"Mostrando {first} a {last} de {totalRecords} registros"
        },
        "labels":{
            "alertsLabel":" alertas",
            "motiveLabels":{
                "licensingDelay":"Retraso en el Licenciamiento",
                "crime":"Crimen",
                "ipvaDelay":"Retraso en el IPVA",
                "boxTruck":"Baúl",
                "tankWithLiquids":"Tanque con Líquidos",
                "concretePipe":"Tubería de Concreto",
                "metal":"Metal",
                "stone":"Piedra",
                "logOfWood":"Tronco de Madera",
                "wood":"Madera",
                "brick":"Ladrillo",
                "rockParticles":"Partículas de Rocas",
                "glass":"Vidrio",
                "gasCylinder":"Botellón de Gas",
                "dumpster":"Contenedor",
                "container":"Contenedor"
            },
            "alert":"Alerta",
            "plate":"Placa",
            "dateAndHour":"Fecha y Hora",
            "registrationDate":"Fecha de Registro",
            "location":"Localidad",
            "address":"Dirección",
            "direction":"Sentido",
            "lane":"Pista",
            "equipment":"Equipo",
            "plateRule":"Regla de la Placa",
            "weight":"Peso",
            "userFeedback":"Usuario Feedback",
            "reason":"Motivo",
            "deadline":"Plazo",
            "status":"Situación",
            "interval":"Intervalo",
            "register":"Registrar",
            "confirmation":"Confirmación",
            "name":"Nombre",
            "yes":"Sí",
            "no":"No",
            "confirm":"Confirmar",
            "cancel":"Cancelar",

            "ia":"IA",
            "brand":"Marca",
            "model":"Modelo",
            "city":"Ciudad",
            "color":"Rubor",
            "state":"Estado",
            "disabled":"Inactivo",
            "publicSecurityIntegration":"Integración de Seguridad Pública",
            "confiability":"IA Confiabilidad",
            "ia-load":"IA Carga",
            "ia-helmet":"IA Casco",
            "ia-classification":"Clasificación",
            "ia-metadados":"Metadatos"
        }
    },
    "calendar": {
        "dayNames": {
          "sunday": "Domingo",
          "monday": "Lunes",
          "tuesday": "Martes",
          "wednesday": "Miércoles",
          "thursday": "Jueves",
          "friday": "Viernes",
          "saturday": "Sábado"
        },
        "dayNamesShort": {
          "sun": "Dom",
          "mon": "Lun",
          "tue": "Mar",
          "wed": "Mié",
          "thu": "Jue",
          "fri": "Vie",
          "sat": "Sáb"
        },
        "dayNamesMin": {
          "su": "Dom",
          "mo": "Lun",
          "tu": "Mar",
          "we": "Mié",
          "th": "Jue",
          "fr": "Vie",
          "sa": "Sáb"
        },
        "monthNames": {
          "january": "Enero",
          "february": "Febrero",
          "march": "Marzo",
          "april": "Abril",
          "may": "Mayo",
          "june": "Junio",
          "july": "Julio",
          "august": "Agosto",
          "september": "Septiembre",
          "october": "Octubre",
          "november": "Noviembre",
          "december": "Diciembre"
        },
        "monthNamesShort": {
          "jan": "Ene",
          "feb": "Feb",
          "mar": "Mar",
          "apr": "Abr",
          "may": "May",
          "jun": "Jun",
          "jul": "Jul",
          "aug": "Ago",
          "sep": "Sep",
          "oct": "Oct",
          "nov": "Nov",
          "dec": "Dic"
        },
        "dateFormat": "dd/mm/yy",
        "emptyMessage": "Sin Respuesta"
    },
    "login":{
        "subTitle":"Vigilancia activa para ciudades inteligentes",
        "password":"Contraseña",
        "logIn":"Ingresar",
        "loginError":"Error al iniciar sesión",

        "authServerCommunicationFail": "Error de comunicación con el servidor de autenticación.",
        "invalidRequest": "Solicitud no válida. Verifique los datos ingresados.",
        "invalidCredentials": "Correo o contraseña incorrectos.",
        "noPermissionAdmin": "Usuario sin permiso para acceder al Administrador.",
        "authInternalError": "Error interno en el servicio de autenticación.",
        "authServiceUnavailable": "Servicio de autenticación temporalmente no disponible."
    },
    "realTime":{
        "empty_1": "Seleccione en ",
        "empty_2": " la(s) cámara(s) deseada(s) para mostrar la transmisión de video",
        "toolbar":{
            "videoWallTooltip":"Visualizar el video wall en pantalla completa",
            "showInfoTooltip":"Mostrar/Ocultar barra de información de las cámaras",
            "videoWallConfig":"Configuraciones del video wall",
            "videoWallOneDevice":"Cambiar el video wall a 1 dispositivo",
            "videoWallFourDevices":"Cambiar el video wall a 4 dispositivos",
            "info":"Seleccione uno o más dispositivos para activar las acciones",
            "videoWallConfigModal":{
                "title":"Configuraciones del Video Wall",
                "rotate":"Rotar",
                "seconds":"Segundos",
                "update":"Actualizar"
            }
        },
        "deviceSideBar":{
            "selected":"Seleccionado(s):",
            "cameras":"Cámaras"
        },
        "groupSideBar":{
            "new":"Nuevo",
            "editGroup":"Editar grupo",
            "removeGroup":"Eliminar grupo",
            "addOrRemove":"Agregar/Quitar del carrusel",
            "toast":{
                "successGroupRegistered":"Grupo registrado con éxito",
                "dywRemoveGroup":"¿Desea realmente eliminar el grupo?",
                "successGroupDeleted":"Grupo eliminado con éxito",
                "successGroupEdited":"Grupo editado con éxito",
                "successDeviceDeleted":"Dispositivo eliminado con éxito"
            },
            "createOrEditModal":{
                "newGroup":"Nuevo Grupo",
                "editGroup":"Editar Grupo"
            }
        },
        "buttons": {
            "devices":"Dispositivos",
            "devicesTooltip":"Seleccionar dispositivos",
            "groups":"Grupos",
            "selectGroups":"Seleccionar grupos"
        },
        "toast":{
            "infoTitle":"Información",
            "minimalDevices":"Esta configuración estará disponible cuando se seleccionen al menos 5 dispositivos",
            "disabledF11":"El botón \"F11\" que ejecuta la función de pantalla completa ha sido deshabilitado en esta página. Para visualizar el video wall en pantalla completa, haga clic en el botón indicado"
        }
    },

    "alert":{
        "toolbar":{
            "noneAlert":"Ningún alerta activo",
            "activeAlert":" Alerta activo",
            "activeAlerts":" Alertas activos",
            "pauseTooltip":"Pausar la actualización de nuevas alertas en pantalla",
            "startTooltip":"Reanudar la actualización de nuevas alertas en pantalla"
        },
        "toast":{
            "attentionTitle":"Atención!",
            "errorTitle":"Error!",
            "successTitle":"Éxito!",
            "warnTitle":"¡Aviso!",
            "noAlert":"Ningún alerta encontrado",
            "errorGetAlert":"Fallo al buscar la lista de alertas",
            "errorGetMotive":"Error al buscar motivos",
            "feedbackError": "Para enviar un feedback es necesario informar el motivo",
            "feedbackSuccess":"Feedback enviado"
        }
    },
    "alertHistory":{
        "toolbar":{
            "alertHistory":"Historial"
        }
    },
    "plates":{
        "toolbar":{
            "licensePlateRegistration":"Registro de Alertas",
            "uploadTooltip":"Anexar archivo de alertas"
        },
        "toast":{
            "errorGetPlate":"Error al buscar alertas!",
            "fourAsterisksError":"No se permiten más de 4 asteriscos",
            "validPlateError":"Ingrese una placa válida",
            "oneOrMoreReasonsError":"Seleccione uno o más motivos",
            "noDeadlineError":"Seleccione un plazo",
            "getRulesError":"Error al buscar reglas existentes",
            "importSuccess":"Alertas importadas con éxito!",
            "somePlates":"¡Algunas alertas no fueron importadas!",
            "errorImportingPlates":"¡Error al importar alertas!",
            "requestError":"Error en la solicitud"
        },
        "registerDialog":{
            "dywRegister":"¿Desea registrar la placa {{plate}} con {{theReasons}}",
            "theReason":" el motivo",
            "theReasons":" los motivos",
            "and":" y ",
            "withinPeriod":" en el plazo ",
            "plate":"¡Placa ",
            "plateRegistered":"¡Placa {{plate}} con {{theReasons}}",
            "successRegistered":" registrada con éxito!",
            "registerError":" ¡Error al registrar la placa!",
            "alreadyAnActiveRule":"Ya existe una regla activa para la placa {{plate}}, para el motivo {{reason}}, en el período del {{startDate}} al {{endDate}}<br>¿Desea sobrescribir?",
            "operationCanceled":"Operación cancelada para la placa {{plate}}, motivo '{{reason}}'"
        },
        "uploadDialog":{
            "attachPlateFile":"Anexar archivo de placas",
            "attentionFormat":"Atención: el archivo adjunto debe seguir el formato del archivo de ejemplo",
            "buttons":{
                "choose":"Elegir",
                "cancel":"Cancelar",
                "exampleFile":"Archivo Ejemplo"
            },
            "uploadError":"Su archivo no fue aceptado por los siguientes errores listados a continuación. Por favor, corríjalos para que la carga se realice con éxito",
            "errorList":{
                "column":"Columna ",
                "line":" Línea "
            }
        },
        "table":{
            "activeDialog":{
                "dywActive":"¿Desea {{option}} la placa {{plate}}?",
                "activate":"activar",
                "deactivate":"desactivar",
                "activated":"activada",
                "deactivated":"desactivada",
                "activeSuccess":"¡Placa {{option}} con éxito!",
                "activeError":"¡Error al {{option}} la placa!"
            },
            "reasonDeactivation":"Motivo de la desactivación"
        }
    },
    "events":{
        "toolbar":{
            "events":"Eventos"
        },
        "details":{
            "detailsTitle":"Detalles del Evento",
            "hasAlert":"Este paso tiene una alerta"
        },
        "toast":{
            "getEventError":"¡Error al buscar eventos!"
        }
    }
}
